<template>
  <div class="overview">
    <nav-bar></nav-bar>
    <div class="content mt-md-4">
      <div class="row">
        <div class="col-md-12 text-left">
          <!-- <button class="btn btn-primary btn-sm" @click="listView = true"></button> -->
          <div class="mt-md-4">
            <meter-reading :location="location"></meter-reading>
          </div>
        </div>
      </div>
    </div>
    <copyright></copyright>
  </div>
</template>

<script>
import Navbar from "./parts/nav";
import MeterReading from "./parts/meter-reading";
import Footer from "./parts/footer";

let data = {
  location: {}
};

export default {
  name: "Overview",
  components: {
    "nav-bar": Navbar,
    "meter-reading": MeterReading,
    copyright: Footer
  },
  beforeCreate: function() {
    // this.$forceUpdate(); // Notice we have to use a $ here
  },
  mounted: function() {
    let city = this.$route.params.city;

    // replace with axios call to backend for specific city
    let data = require("../data.json");
    this.location = data.locations.find(function(location) {
      return location.name.toLowerCase() === city.toLowerCase();
    });
  },
  data: function() {
    return data;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  padding: 0 20px;
  margin-bottom: 50px;
}

a.anchor-card {
  color: #001d3e;
  text-decoration: none;
}

@media screen and (max-width: 768px) {
  .text-left {
      padding-top: 5px;
  }
}
</style>
